export default __webpack_public_path__ + "static/media/vote.25ef91ff.png";